import React from 'react';
import Autocomplete from "react-google-autocomplete";

export const {
    REACT_APP_GOOGLE_MAP_API_KEY
} = process.env;


const GoogleSearchAddress = ({ onPlaceSelected, ...props}: any) => {
    return <Autocomplete
        apiKey={REACT_APP_GOOGLE_MAP_API_KEY}
        onPlaceSelected={onPlaceSelected}
        options={{
            types: ["geocode", "establishment"],
        }}
        libraries={["drawing", "geometry", "places"]}
        {...props}
    />
};

export default GoogleSearchAddress;





// import React, { useEffect, useRef } from 'react';

// export const {
//     REACT_APP_GOOGLE_MAP_API_KEY
// } = process.env;

// const GoogleSearchAddress = ({ onPlaceSelected, ...props }: any) => {
//     const containerRef = useRef(null);

//     useEffect(() => {
//         // Remove any duplicate Google Maps scripts
//         const existingScript: any = document.querySelector(`script[src*="maps.googleapis.com"]`);
//         if (existingScript && !existingScript.src.includes("v=beta")) {
//             existingScript.remove();
//         }

//         // Load the Google Maps script with v=beta
//         if (!document.querySelector(`script[src*="maps.googleapis.com"][src*="v=beta"]`)) {
//             const script = document.createElement("script");
//             script.src = `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAP_API_KEY}&libraries=drawing,geometry,places&v=beta`;
//             script.async = true;
//             script.defer = true;
//             document.head.appendChild(script);

//             script.onload = () => {
//                 initializePlaceAutocomplete();
//             };
//         } else if (window.google?.maps) {
//             initializePlaceAutocomplete();
//         }

//         async function initializePlaceAutocomplete() {
//             if (containerRef.current && window.google?.maps) {
//                 try {
//                     await window.google.maps.importLibrary("places");

//                     const placeAutocomplete = new window.google.maps.places.PlaceAutocompleteElement({
//                         types: ["geocode", "establishment"],
//                     });

//                     containerRef.current.appendChild(placeAutocomplete);
                    
//                     placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
//                         const place = placePrediction.toPlace();
//                         await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'location', 'types'] });

//                         if (onPlaceSelected) {
//                             onPlaceSelected(place.toJSON());
//                         }
//                     });

//                     setTimeout(() => {
//                         const inputElement = containerRef.current?.querySelector("input");
//                         if (inputElement) {
//                           inputElement.setAttribute("placeholder", "Insert address or coordinate");
//                         }
//                     }, 100);
              
//                 } catch (error) {
//                     console.error("Error initializing PlaceAutocompleteElement:", error);
//                 }
//             }
//         }

//         return () => {
//             // Cleanup: Remove the PlaceAutocompleteElement if it exists
//             if (containerRef.current) {
//                 containerRef.current.innerHTML = "";
//             }
//         };
//     }, [onPlaceSelected]);


//     return (
//         <div ref={containerRef} {...props}></div>
//     );
// };

// export default GoogleSearchAddress;